module.exports = __webpack_public_path__ + "img/1.0f969c64.jpg";